export default __webpack_public_path__ + "static/media/link_big.f2d511d5.svg";